<form [formGroup]="form">
  <div class="gap-sm grid" formArrayName="techniquesAnimation">
    @for (form of techniquesAnimation.controls; track $index; let idx = $index) {
      <app-expansion-panel
        [titre]="'Technique d\'animation ' + (idx + 1)"
        [item]="idx"
        [isOpen]="true"
        [actions]="techniqueActions"
      >
        <div class="gap-lg p-lg grid" [formGroupName]="idx">
          <div hlmField>
            <label [for]="'nom-' + idx" hlmFieldLabel>Libellé <span class="text-danger">*</span></label>
            <input [id]="'nom-' + idx" hlmInput type="text" formControlName="libelle" required />
          </div>
          <div hlmField>
            <label [for]="'lien-' + idx" hlmFieldLabel>Lien vers le PDF</label>
            <input [id]="'lien-' + idx" hlmInput type="text" formControlName="lien" />
          </div>
        </div>
      </app-expansion-panel>
    }
    @if (!techniqueAnimation()) {
      <app-button-add-new (click)="ajouterTechniqueAnimation()" label="Ajouter une autre technique d'animation" />
    }
  </div>
</form>
